import React, { FC } from "react";

export const PlayVideoPlayerIcon: FC<any> = () => {
    return (
        <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.500001 0.902123L7.0566 5L0.500001 9.09788L0.500001 0.902123Z" />
        </svg>
    );
}
